<template lang='pug'>
.comp-parts-verify
  h2.comp-parts-verify__subheader(v-if="!!messageData.title")
    | {{messageData.title}}
  p.comp-parts-verify__message(v-if="!!messageData.message")
    | {{messageData.message}}
  ExtLink(
    v-if="linkPath"
    :text="linkText"
    :to="linkPath"
  )
</template>

<script>
import ExtLink from '@/components/ext/Link.vue';

export default {
  name: 'CompPartsVerify',

  components: {
    ExtLink,
  },

  props: {
    messageData: {
      type: Object,
      default: null,
    },

    linkPath: {
      type: [String, Object],
      default: '',
    },

    linkText: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang='stylus' scoped>
@import '../../../../stylus/helpers/mediaqueriesStep'

.comp-parts-verify
  margin 20px 0 40px
  padding 40px 20px
  background-color rgba(#ededed, .5)
  border-radius 4px

  +tablet()
    margin 40px 0 80px
    padding 60px 76px

  +desktop()
    margin 40px 0 160px
    padding 80px 154px

  &__subheader
    margin-bottom 25px
    font-family "Open Sans", sans-serif
    font-weight 700
    font-size 16px
    line-height 1.4
    text-transform uppercase
    user-select text
    cursor text

  &__message
    margin-bottom 22px
    font-size 18px
    line-height 25px
    color #424242
</style>



// WEBPACK FOOTER //
// Email.vue?ec1b0f4e